import type { PaginationState } from './types';

export function isTotalKnown(
  pagination: PaginationState,
): pagination is PaginationState & { totalPages: number } {
  return pagination.totalPages !== undefined;
}

export function hasMultiplePages(pagination: PaginationState): boolean {
  if (isTotalKnown(pagination)) return pagination.totalPages > 1;
  return pagination.page > 1 || pagination.hasMore === true;
}

export function hasNextPage(pagination: PaginationState): boolean {
  if (isTotalKnown(pagination)) return pagination.page < Math.max(1, pagination.totalPages);
  return pagination.hasMore === true;
}

/** Janela de até três páginas centrada na atual, como no desenho original do DataTable. */
export function visiblePageNumbers(page: number, totalPages: number): number[] {
  const maxPage = Math.max(1, totalPages);
  return Array.from({ length: Math.min(3, maxPage) }, (_, index) => {
    if (maxPage <= 3 || page <= 2) return index + 1;
    if (page >= maxPage - 1) return maxPage - 2 + index;
    return page - 1 + index;
  });
}
